<template>
  <div>
    <NotAuthPage :jumpParams="jumpV2Params" isForcedRedirect>
      <div class="header_tabs">
        <div style="font-weight: bolder; font-size: 18px">现有页面</div>
        <div>
          <el-tag class="table_tag" @close="closeTab(index)" @click.native="changeTabs(index, item.id)"
            :type="tab_index === index ? '' : 'info'" :closable="editTableBtn && tabList.length !== 1"
            v-for="(item, index) in tabList" :key="index">
            <span v-show="!editTableBtn">{{ item.title }}</span>
            <el-input style="width: 140px" v-show="editTableBtn" v-model="item.title" placeholder="请输入内容"
              size="mini"></el-input>
          </el-tag>
          <span v-if="!btnsFlag" class="myTooltip">
            <i style="font-size:20px" class="el-icon-circle-plus-outline table_tag"
              @click="() => { addShowBtn = true; btnsFlag = true }"></i>
            <i style="font-size:20px" class="el-icon-edit table_tag" v-if="tabList.length" @click="editTabs"></i>
            <div v-if="!showFlag" class="tooltiptext ">
              请添加一个sdk引用页面
            </div>
          </span>
          <span v-if="editTableBtn">
            <el-button size="mini" type="primary" @click="deleteTab">保存</el-button>
            <el-button size="mini" type="danger" @click="onDeleteTabs">取消</el-button>
          </span>
        </div>
        <div style="margin-top:15px">
          <el-input style="width:140px" v-model="tab_title" size="mini" placeholder="请输入内容" :maxlength="10"
            v-if="addShowBtn"></el-input>
          <div style="margin-top:15px" v-if="addShowBtn">
            <el-button size="mini" type="primary" @click="addTab">保存</el-button>
            <el-button size="mini" type="danger" @click="onTab">取消</el-button>
          </div>
        </div>
      </div>
      <div class="page_sdk" v-loading="loading" v-if="showFlag">
        <!-- 左边部分 -->
        <div class="left_box">
          <p style="font-weight: bolder; font-size: 18px">SDK引用清单页面URL</p>
          <!-- 复制地址 -->
          <p>
            <el-link :underline="false" type="primary" @click="goH5(urlShow)">{{
              urlShow
            }}</el-link>
          </p>
          <p>
            <el-button type="primary" size="mini" @click="copyText(urlShow)">复制</el-button>
          </p>
          <p style="color: red; font-size: 12px">
            如果不想用中台域名，自己配置自定义域名反向代理到中台域名上（原域名后面拼接的参数依然要带上）,链接引用方式切记不能用ifirame！！！
          </p>
          <p style="margin-top: 20px; font-weight: bolder; font-size: 18px">
            选择所引用的SDK
          </p>
          <p class="tips-text" v-if="list.length">当前已新增{{ list.length }}条</p>
          <!-- 配置列表 -->
          <div class="sdk-list" ref="sdkList">
            <div v-for="(item, index) in list" :key="index" style="margin-bottom: 20px">
              <el-select v-model="item.id" placeholder="请选择" @change="changeH5page" filterable>
                <el-option v-for="_item in selectList" :key="_item.value" :label="_item.title" :value="_item.id"
                  @mouseover="showDetails(_item.details)" @mouseout="hideDetails"
                  :disabled="selectedItemIds.includes(_item.id)">
                  <span style="float: left">{{ _item.title }}</span>
                  <el-popover placement="right" style="float: right" width="200" trigger="hover"
                    :disabled="selectedItemIds.includes(_item.id)">
                    <div class="card_list">
                      <div class="font_bolr">
                        {{ _item.title }}
                      </div>
                      <div>
                        <p class="font_bolr">涉及个人信息:</p>
                        <p>{{ _item.involve_personal_info }}</p>
                      </div>
                      <div>
                        <p>
                          <span class="font_bolr">使用目的：</span>
                          {{ _item.use_purpose }}
                        </p>
                      </div>
                      <div>
                        <p>
                          <span class="font_bolr">使用场景：</span>
                          {{ _item.use_scene }}
                        </p>
                      </div>
                      <div>
                        <p>
                          <span class="font_bolr">采集方式：</span>{{ item.collect_type }}
                        </p>
                      </div>
                      <div>
                        <p>
                          <span class="font_bolr">合作方主体：</span>{{ item.company_subject }}
                        </p>
                      </div>
                      <div>
                        <p>
                          <span class="font_bolr">合作方隐私链接：</span>
                          <el-link :underline="false" type="primary" @click="goH5(item.secrecy_link)">{{
                            item.secrecy_link
                          }}</el-link>
                        </p>
                      </div>
                      <div>
                        <p>
                          <span class="font_bolr">合作方官网链接：</span>
                          <el-link :underline="false" type="primary" @click="goH5(item.official_link)">{{
                            item.official_link
                          }}</el-link>
                        </p>
                      </div>
                    </div>
                    <el-button type="text" slot="reference">详情</el-button>
                  </el-popover>
                </el-option>
              </el-select>
              <el-button @click="delData(index, item.id)" style="margin-left: 30px" type="danger"
                size="small">删除</el-button>
            </div>
          </div>

          <div class="btn-wrapper">
            <!-- 添加按钮 -->
            <div class="add">
              <div class="add_content" @click="addList">
                <span class="el-icon-circle-plus-outline" style="font-size: 36px"></span>
                <div style="color: #02a7f0">新增</div>
              </div>
            </div>
            <!-- 保存按钮 -->
            <div class="add">
              <el-button style="width: 120px" @click="submitBtn" type="primary">保存</el-button>
            </div>
          </div>

          <!-- 选择引用的SDK -->
        </div>
        <!-- 右边手机展示部分 -->
        <div class="rigth_box">
          <p style="font-weight: bolder; font-size: 18px">SDK引用清单页面预览</p>
          <div class="iphone_img">
            <div class="iphone_img_content">
              <p class="title">第三方信息共享服务商清单</p>
              <div class="preface">
                为保障相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方服务商提供的软件开发包（SDK）、应用程序接口（API）、应用程序插件等代码或通过其他合作方式，以实现相关目的。第三方服务商对您信息具体的处理情况请参见其隐私政策或服务协议。请注意，第三方服务商代码可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。以下是我们接入的主要的第三方服务商的信息：
              </div>
              <div>
                <div style="margin-bottom: 30px" class="card_list" v-for="(item, index) in h5List" :key="index">
                  <div class="font_bolr">
                    {{ item.title }}
                  </div>
                  <div>
                    <p class="font_bolr">涉及个人信息:</p>
                    <p>{{ item.involve_personal_info }}</p>
                  </div>
                  <div>
                    <p>
                      <span class="font_bolr">使用目的：</span>
                      {{ item.use_purpose }}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="font_bolr">使用场景：</span>
                      {{ item.use_scene }}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="font_bolr">采集方式：</span>{{ item.collect_type }}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="font_bolr">合作方主体：</span>{{ item.company_subject }}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="font_bolr">合作方隐私链接：</span>
                      <el-link :underline="false" type="primary" @click="goH5(item.secrecy_link)">{{ item.secrecy_link
                        }}</el-link>
                    </p>
                  </div>
                  <div>
                    <p>
                      <span class="font_bolr">合作方官网链接：</span>
                      <el-link :underline="false" type="primary" @click="goH5(item.official_link)">{{ item.official_link
                        }}</el-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </NotAuthPage>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        title: "", //名称
        collect_type: "", //采集方式
        use_scene: "", //使用场景
        company_subject: "", //合作方主体
        app_ids: [], //应用
      },
      tableOpt: {
        currentPage: 1,
        pageSize: 2000,
      },
      selectList: [], //下拉列表数据
      list: [], //选择的数据
      h5List: [], //h5的数据
      url: "https://data.nineton.cn/h5/sdk",
      loading: false,
      urlShow: "",
      tabList: [

      ],//配置页数据
      addShowBtn: false,
      editTableBtn: false,
      tab_title: "默认页面",//新增tab
      tabTitleIds: [],//tab的id列表
      btnsFlag: false, //按钮隐藏显示
      tab_index: 0,
      showFlag: false,
      jumpV2Params: {
        path: "/statistical_centre/other/SDK_config_list",
        appid: null // 初始化为 null 或其他默认值
      }
    };
  },
  created() {
    // 获取跳转v2需要的参数
    this.jumpV2Params.appid = this.$route.query.appId;
  },
  mounted() {
    return
    this.getReport();
  },
  computed: {
    selectedItemIds() {
      return this.list.map((item) => item.id);
    },
  },
  methods: {
    // 链接跳转
    goH5(url) {
      window.open(url, "_blank");
    },
    // 复制文本
    copyText(text) {
      let input = document.createElement("input");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      input.select();
      let result;
      try {
        result = document.execCommand("copy");
        if (result === "unsuccessful") {
          this.$message.error("复制失败");
        } else {
          this.$message({
            message: "复制成功",
            type: "success",
          });
        }
      } catch (err) {
        this.$message.error("复制失败");
      }
      document.body.removeChild(input);
    },
    // 获取列表
    async getList() {
      this.loading = true;
      const { appId } = this.$router.history.current.query;
      const [err, res] = await this.$http.post("App/externalSdkQuoteList", {
        app_id: appId,
        page_id: this.page_id,
      });
      if (err) return;
      this.list = res.list ? res.list : [];
      this.urlShow = this.url + "?key=" + res.unique_link;
      this.loading = false;
    },
    //获取下拉列表
    async getReport() {
      this.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("Other/externalSdkList", {
        ...searchForm,
        ...tableOpt,
        app_ids: searchForm.app_ids,
        get_app_name: "no",
      });
      if (err) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 2000,
        };
        return;
      }
      const { list, currentPage, total } = res;
      this.selectList = list;
      this.getSdkPageList();
    },
    // 添加列表
    addList() {
      if (this.selectList.length == this.list.length) {
        this.$message.error("已选择SDK数量达到上限");
        return;
      }
      let hasEmptyId = this.list.some((obj) => !obj.id);
      if (hasEmptyId) {
        this.$message.error("请选择SDK后再继续新增");
        return;
      } else {
        this.list.push({ id: "" });
        // 滚动到最底部
        this.$nextTick(() => {
          const sdkref = this.$refs.sdkList
          sdkref.style.transition = 'scroll-behavior 0.3s';
          sdkref.scrollTo({ top: sdkref.scrollHeight, behavior: 'smooth' });
        })

      }
    },
    // 删除按钮
    delData(index, id) {
      this.$confirm("确认删除当前SDK？").then(async (_) => {
        this.list.splice(index, 1);
      });
    },
    // 鼠标移入下拉框
    showDetails(details) {
      this.details = details;
      this.showTooltip = true;
    },
    // 移出下拉框
    hideDetails() {
      this.showTooltip = false;
    },
    //改变H5展示页面
    changeH5page() { },
    // 保存按钮
    async submitBtn() {
      let hasEmptyId = this.list.some((obj) => !obj.id);
      if (hasEmptyId) {
        this.$message.error("请选择SDK后再保存");
        return;
      } else {
        const { appId } = this.$router.history.current.query;
        const [err, res] = await this.$http.post("App/externalSdkQuoteSave", {
          app_id: appId,
          sdk_ids: this.selectedItemIds,
          page_id: this.page_id,
        });
        if (err) return;
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.getList();
      }
    },
    // 新增tab
    async addTab() {
      this.addShowBtn = false;
      this.btnsFlag = false;
      if (this.tab_title === "") {
        this.$message.error("标题不可为空")
        return
      }
      const { appId } = this.$router.history.current.query;
      const [err, res] = await this.$http.post("App/externalSdkPageAdd", {
        app_id: appId,
        title: this.tab_title,
      });
      if (err) {
        return;
      }
      this.$message({
        message: "新增成功",
        type: "success",
      });
      this.tab_title = "默认页面"
      const [err2, res2] = await this.$http.post("App/externalSdkPageList", {
        currentPage: 1,
        pageSize: 100,
        app_id: appId,
      });
      if (err2) {
        return;
      }
      this.tabList = res2.list;
      this.page_id = res2.list ? res2.list[res2.list.length - 1].id : ""
      this.tab_index = res2.list.length - 1
      if (res2.list) {
        this.showFlag = true
        this.getList();
      } else {
        this.showFlag = false
        this.loading = false;
      }
    },
    onTab() {
      this.addShowBtn = false;
      this.btnsFlag = false;
      this.tab_title = "默认页面"
      this.tab_index = 0
    },
    // 获取页面ID（page_id）
    async getSdkPageList() {
      const { appId } = this.$router.history.current.query;
      const [err, res] = await this.$http.post("App/externalSdkPageList", {
        currentPage: 1,
        pageSize: 100,
        app_id: appId,
      });
      if (err) {
        return;
      }
      this.tabList = res.list;
      this.page_id = res.list ? res.list[0].id : ""
      if (res.list) {
        this.showFlag = true
        this.getList();
      } else {
        this.showFlag = false
        this.loading = false;
      }
    },
    // 开启tab编辑
    editTabs() {
      this.editTableBtn = true;
      this.btnsFlag = true
      this.tabList_copy = JSON.parse(JSON.stringify(this.tabList));
      this.tab_index = ""
    },
    // 关闭close的回调参数
    closeTab(index) {
      this.tabList.splice(index, 1);
    },
    // 保存删除后的tab
    async deleteTab(id) {
      if (this.tabList.some(item => item.title === "")) {
        this.$message.error("标题不可为空")
        return
      }
      this.editTableBtn = false;
      this.btnsFlag = false;
      const { appId } = this.$router.history.current.query;
      const [err, res] = await this.$http.post("App/externalSdkPageChange", {
        app_id: appId,
        data: this.tabList,
      });
      if (err) {
        return;
      }
      this.$message({
        message: "编辑成功",
        type: "success",
      });
      this.getSdkPageList();
      this.tab_index = 0;
    },
    // 取消删除行为
    onDeleteTabs() {
      this.tabList = JSON.parse(JSON.stringify(this.tabList_copy));
      this.editTableBtn = false;
      this.btnsFlag = false;
      this.tab_index = 0;
    },
    //tabs点击事件
    changeTabs(index, id) {
      if (!this.editTableBtn) {
        this.tab_index = index;
        this.page_id = id
        this.getList();
      }
    }
  },
  watch: {
    list: {
      handler(newList) {
        let arr = [];
        newList.forEach((item, index) => {
          this.selectList.forEach((option) => {
            if (option.id === item.id) {
              arr.push(option);
            }
          });
        });
        this.h5List = arr;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.srocll_btn {
  /*   width: 1200px;
  overflow-x: auto; */
}

.header_tabs {
  padding: 10px 30px;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;

  /deep/.el-input {
    width: 140px !important;
  }

  /deep/.el-input__inner {
    width: 140px !important;
    padding: 5px;
  }
}

.table_tag {
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.page_sdk {
  display: flex;
  padding: 0 30px;
  background: #fff;
  border-radius: 10px;

  .left_box {
    width: 600px;
  }

  .rigth_box {
    margin-left: 50px;
  }
}

.apple_img {
  height: 675px;
  width: 350px;
}

/* 定义滚动条的宽度 */
::-webkit-scrollbar {
  width: 0px;
}

/* 定义滚动条轨道的样式 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* 定义滚动条的样式 */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* 当鼠标在滚动条上时，修改滚动条的颜色 */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/deep/.el-input__inner {
  width: 280px;
}

.iphone_img {
  height: 675px;
  width: 350px;
  background-image: url(./img/iphone_demo.png);
  background-size: 352.5px 680px;
  padding: 45px 30px 35px 30px;

  .iphone_img_content {
    font-size: 14px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow: auto;

    .title {
      text-align: center;
      padding-bottom: 5px;
      border-bottom: 1px solid #000;
    }

    .preface {
      font-size: 12px;
      margin-bottom: 50px;
    }
  }
}

.add {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  text-align: center;

  .add_content {
    cursor: pointer;
  }
}

.font_bolr {
  font-weight: bolder;
}

.card_list {
  font-size: 12px;

  p {
    margin: 0;
    padding: 0;
  }
}

a {
  word-break: break-all;
}

.sdk-list {
  width: 400px;
  // padding: 15px;
  scroll-behavior: smooth;
  height: 300px;
  overflow: auto;

  &::-webkit-scrollbar {
    background: #DDD;
    width: 5px;
  }
}

.tips-text {
  font-size: 14px;
}

.myTooltip {
  position: relative;

  .tooltiptext {
    // visibility: hidden;
    width: 200px;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 4px;

    /* Position the tooltip text */
    position: absolute;
    z-index: 1;
    top: 150%;
    /* Place the tooltip text below */
    left: 0;
    margin-left: -20px;

    /* Fade in tooltip */
    /*     opacity: 0;
    transition: opacity 0.3s; */

    &::after {
      content: "";
      position: absolute;
      bottom: 100%;
      /* At the top of the tooltip */
      left: 30px;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #555 transparent;
    }
  }
}


.btn-wrapper {
  /*   display: flex;
  align-items: center; */
}
</style>
